import { SxProps, Theme } from "@mui/material";
import type { Deal } from "../../api/types";
import CustomAutocomplete from "./CustomAutocomplete";
import { getDealLabel } from "../../utilities/utils";

interface Props {
	deals: Deal[];
	selectedDeals: Deal[];
	loading: boolean;
	setSelectedDeals: (deals: Deal[]) => void;
	sx?: SxProps<Theme>;
}

export default function DealSelectionAutocomplete(props: Props) {
	return (
		<CustomAutocomplete
			loading={props.loading}
			options={props.deals.sort((a, b) => {
				const aLabel = getDealLabel(a);
				const bLabel = getDealLabel(b);
				return aLabel.localeCompare(bLabel);
			})}
			optionFormatter={(option) => getDealLabel(option) ?? ""}
			selectedOption={props.selectedDeals[0] ?? null}
			onChange={(value) => {
				props.setSelectedDeals(value ? [value] : []);
			}}
			label="Select the most common sampling configuration you need right now"
			sx={props.sx}
		/>
	);
}
